import { SET_ANALYTICS } from './actionTypes'
import { AnalyticsActionTypes } from './types'

const initialState = {
  pageType: "",
  viewName: "",
  event: "",
  eventAction: "",
  eventLabel: "", 
  eventCategory: '',
  eventValue: null,
  nonInteraction: null,
  valuation: 0
}

export default (state = initialState, action: AnalyticsActionTypes) => {
  switch (action.type) {
    case SET_ANALYTICS:
      return { ...state, ...action.payload }
    default:
      return state
  }
}
